import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  crudActions,
  DatasetTableAction,
  DatasetTableConfig,
  dateColumn,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';

export interface WorkflowTableRow {
  enabled: boolean,
  name: string,
  published: boolean,
  updatedAt: number;
  createddAt: number;
  graphId: string,
}

export type WorkflowCellContext =
  CellTemplateContext<WorkflowTableRow>;

export interface WorkflowTableDependencies {
  toggleCellTemplate: TemplateRef<WorkflowCellContext>;
  publishedCellTemplate: TemplateRef<WorkflowCellContext>;
}

const viewRunList: DatasetTableAction<WorkflowTableRow> = {
  id: 'viewRunList',
  icon: 'ui-icon-list-view-2',
  tooltip: 'FLOW_CHART.RUN_LIST_TABLE.OPEN_RUN_LIST',
  tooltipClass: 'sidebar-tooltip',
  showInline: true,
  visible: (row) => !!row.published,
};

export function createWorkflowTableConfig(
  dependencies: WorkflowTableDependencies,
): DatasetTableConfig<WorkflowTableRow> {
  const builder = new ColumnBuilder<WorkflowTableRow>();

  return new TableConfigBuilder<WorkflowTableRow>()
    .columns([
      builder
        .column('enabled' as keyof WorkflowTableRow)
        .label('')
        .width('60px')
        .cellTemplate(dependencies.toggleCellTemplate)
        .detailsModalLabel('HTTP_REQUEST_LIST.TABLE.ENABLED')
        .build(),
      textColumn<WorkflowTableRow>('name', 'FLOW_CHART.TABLE_NAME', {
        width: 'minmax(150px, 1fr)',
        mobileVisible: true,
      }),
      builder
        .column('published' as keyof WorkflowTableRow)
        .label('FLOW_CHART.PUBLISHED')
        .width('minmax(150px, 1fr)')
        .cellTemplate(dependencies.publishedCellTemplate)
        .detailsModalLabel('FLOW_CHART.PUBLISHED')
        .alignCenter()
        .build(),
      dateColumn<WorkflowTableRow>('createddAt', 'FLOW_CHART.CREATED_AT', {
        width: 'minmax(100px, 0.8fr)',
        customFormat: 'YYYY MMM DD, hh:mm A',
        showTimeZone: true,
        mobileVisible: true,
      }),
      dateColumn<WorkflowTableRow>('updatedAt', 'FLOW_CHART.UPDATED_AT', {
        width: 'minmax(100px, 0.8fr)',
        customFormat: 'YYYY MMM DD, hh:mm A',
        showTimeZone: true,
        mobileVisible: true,
      }),
    ])
    .actions([
      viewRunList,
      ...crudActions<WorkflowTableRow>(),
    ])
    .trackBy('graphId')
    .rowHeight(52)
    .extend({
      responsive: {
        breakpoints: {
          card: 520
        },
      }
    })
    .build();
}
